/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/preformatted",
  category: "formatting",
  attributes: {
    content: {
      type: "string",
      source: "html",
      selector: "pre",
      "default": ""
    }
  }
};
import save from './save';
import transforms from './transforms';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Preformatted'),
  description: __('Add text that respects your spacing and tabs, and also allows styling.'),
  icon: icon,
  example: {
    attributes: {
      content: __('EXT. XANADU - FAINT DAWN - 1940 (MINIATURE)') + '\n' + __('Window, very small in the distance, illuminated.') + '\n' + __('All around this is an almost totally black screen. Now, as the camera moves slowly towards the window which is almost a postage stamp in the frame, other forms appear;')
    }
  },
  transforms: transforms,
  edit: edit,
  save: save,
  merge: function merge(attributes, attributesToMerge) {
    return {
      content: attributes.content + attributesToMerge.content
    };
  }
};
//# sourceMappingURL=index.js.map